import { DrawerBody } from '@chakra-ui/react';

export const UiDrawerBody = DrawerBody;
